/** @file anchorLabel: the words after "Anchor (px)": which joint the part's anchor sits on. */
import type { RotateMode } from '@zilo/pose3d-format/types/facet';

/**
 * `rotate: parent`: "at <node> joint (bone end); the top stretches to <parent>" (no parent: "to nothing (root)");
 * every other rule: "sits on <node>".
 */
export function anchorLabel(rotate: RotateMode, node: string, parent: string | undefined): string {
  if (rotate !== 'parent') return `sits on ${node}`;
  return `at ${node} joint (bone end); the top stretches to ${parent ?? 'nothing (root)'}`;
}
